import React from 'react'
import { Link } from 'react-router-dom'
import { SEOHead } from '../components/ui/SEOHead'
import { TerminalWindow } from '../components/terminal/TerminalWindow'

export const SubscribeConfirmedPage: React.FC = () => (
  <>
    <SEOHead title="Subscription Confirmed" />
    <TerminalWindow title="subscribe.sh">
      <div
        style={{
          fontFamily: "'JetBrains Mono', 'Courier New', monospace",
          fontSize: '0.9rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
        }}
      >
        <div style={{ color: 'var(--accent-teal)' }}>
          ✓ Subscription confirmed!
        </div>
        <div style={{ color: 'var(--text-secondary)' }}>
          You&apos;re on the list. New posts will be delivered to your inbox.
        </div>
        <Link to="/" style={{ color: 'var(--accent-blue)', fontSize: '0.85rem' }}>
          [← back to home]
        </Link>
      </div>
    </TerminalWindow>
  </>
)
